// Loại dự toán
export default {
  FirstOfYear: 0,
  Addition: 1
};
